import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { st, FormControl, Form, FormMessage, Button, Link } from "lib/index";
import AuthLayout from "modules/app/AuthLayout";
import { stateSelector, initializeModel, updateModel, submit } from "./index";

@connect(
  (state) => ({
    model: stateSelector(state).form.model,
    valid: stateSelector(state).form.valid,
    submitLoading: stateSelector(state).form.submitLoading,
    errors: stateSelector(state).form.errors,
  }),
  (dispatch) =>
    bindActionCreators(
      {
        initializeModel,
        updateModel,
        submit,
      },
      dispatch
    )
)
export default class SendResetPasswordInstructionsView extends React.PureComponent {
  componentDidMount() {
    this.props.initializeModel({ email: null });
  }

  handleModelPropChange(prop, value) {
    const { model, updateModel } = this.props;
    updateModel({ ...model, [prop]: value });
  }

  handleSubmit(event) {
    const { submit } = this.props;
    event.preventDefault();
    submit();
  }

  render() {
    const { model, submitLoading, valid, errors } = this.props;

    return (
      <AuthLayout.Container>
        <AuthLayout.Box title={I18n.t("papp.auth.SendResetPasswordInstructionsView.title")}>
          {model && (
            <Form onSubmit={this.handleSubmit.bind(this)} error={!valid} loading={submitLoading}>
              {!!errors.base && <FormMessage error={errors.base} />}

              <FormControl.InputFormGroup
                {...FormControl.addProps(`model.email`, { errors })}
                value={model.email}
                onChange={this.handleModelPropChange.bind(this, "email")}
                label={I18n.t("papp.auth.SendResetPasswordInstructionsView.email_label")}
                help={I18n.t("papp.auth.SendResetPasswordInstructionsView.email_help")}
                type="email"
                required
              />

              <Button as={Link} basic floated="left" to="/login" content={I18n.t("papp.common.go_back")} />

              <Button
                type="submit"
                primary
                floated="right"
                content={I18n.t("papp.auth.SendResetPasswordInstructionsView.submit")}
              />
            </Form>
          )}
        </AuthLayout.Box>
      </AuthLayout.Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/auth/SendResetPasswordInstructionsView/SendResetPasswordInstructionsView.jsx